import React, { useState, useContext } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";
import { Editor } from "./MostrarImagen"; // Importación corregida según tu estructura

const Create = () => {
  const { dbCategories, loadProducts } = useContext(CartContext);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  // Manejo de archivos e imágenes (Tal cual estaba)
  const [images, setImages] = useState([null, null, null]);
  const [previews, setPreviews] = useState(["", "", ""]);

  const initialForm = {
    titulo: "",
    categoria: "",
    precio: "",
    stock: "1",
    descripcion: "",
    estado: "activo",
  };

  const [formData, setFormData] = useState(initialForm);

  const handleClose = () => {
    setShow(false);
    setFormData(initialForm);
    setImages([null, null, null]);
    setPreviews(["", "", ""]);
  };

  const handleImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);

      const newPreviews = [...previews];
      newPreviews[index] = URL.createObjectURL(file);
      setPreviews(newPreviews);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    // Pasamos los textos (titulo, categoria, precio, stock, descripcion, estado)
    Object.keys(formData).forEach((key) => data.append(key, formData[key]));

    // Pasamos las imágenes físicas image_0, image_1, image_2
    images.forEach((file, i) => {
      if (file) data.append(`image_${i}`, file);
    });

    try {
      const resp = await fetch(
        "https://espacioanalogico.com.ar/api/save_product.php",
        {
          method: "POST",
          body: data,
          credentials: "include",
        },
      );

      const res = await resp.json();

      if (res.success) {
        Swal.fire("Éxito", "Producto creado en MySQL", "success");
        loadProducts();
        handleClose();
      } else {
        Swal.fire("Error", res.message || "Error al guardar", "error");
      }
    } catch (err) {
      Swal.fire("Error", "No se pudo conectar con el servidor", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="boton"
        onClick={() => setShow(true)}
        style={{ cursor: "pointer" }}
      >
        Cargar nuevo producto
      </div>

      <Modal show={show} onHide={handleClose} size="md" centered>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Nuevo Producto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* SELECTORES DE IMÁGENES */}
            <div className="row g-2 mb-3">
              {[0, 1, 2].map((i) => (
                <div key={i} className="col-4">
                  <div
                    onClick={() =>
                      document.getElementById(`file-create-${i}`).click()
                    }
                    className="border rounded d-flex align-items-center justify-content-center bg-light"
                    style={{
                      height: "100px",
                      cursor: "pointer",
                      overflow: "hidden",
                    }}
                  >
                    {previews[i] ? (
                      <img
                        src={previews[i]}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        alt=""
                      />
                    ) : (
                      <span className="text-muted small">Subir foto</span>
                    )}
                  </div>
                  <input
                    type="file"
                    id={`file-create-${i}`}
                    hidden
                    onChange={(e) => handleImageChange(i, e)}
                  />
                </div>
              ))}
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Categoría</Form.Label>
              <Form.Select
                required
                value={formData.categoria}
                onChange={(e) =>
                  setFormData({ ...formData, categoria: e.target.value })
                }
              >
                <option value="">Seleccionar...</option>
                {dbCategories.map((cat) => (
                  <option key={cat.id} value={cat.nombre}>
                    {cat.nombre}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Título</Form.Label>
              <Form.Control
                required
                value={formData.titulo}
                onChange={(e) =>
                  setFormData({ ...formData, titulo: e.target.value })
                }
              />
            </Form.Group>

            {/* EDITOR DE TEXTO ENRIQUECIDO */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Descripción</Form.Label>
              <Editor
                descripcion={formData.descripcion}
                cargarDescripcion={(val) =>
                  setFormData({ ...formData, descripcion: val })
                }
              />
            </Form.Group>

            <div className="row">
              <div className="col-6">
                <Form.Label className="fw-bold">Precio ($)</Form.Label>
                <Form.Control
                  type="number"
                  required
                  value={formData.precio}
                  onChange={(e) =>
                    setFormData({ ...formData, precio: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <Form.Label className="fw-bold">Stock</Form.Label>
                <Form.Control
                  type="number"
                  required
                  value={formData.stock}
                  onChange={(e) =>
                    setFormData({ ...formData, stock: e.target.value })
                  }
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={loading}
            >
              {loading ? "GUARDANDO..." : "CREAR PRODUCTO"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Create;
